module.exports = __webpack_public_path__ + "static/media/university-of-helsinki-logo.130b65bd.webp";